export default __webpack_public_path__ + "static/media/behavior-footer-icon.85ea889f.svg";